import { HideSubItemShop } from '@components/Page/Header/shop-menu/HideSubItemShop'
import { Container } from '@gassan-ui'
import { NavigationContent } from '@lib/kontent/navigation-helpers/normalize-navigation-content'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import { FC, useState } from 'react'
import MenuButton from '../MenuButton'
import { MenuLabel } from '../MenuLabel'
import { MenuList } from '../MenuList'
import { HeaderShopMenuJewelry } from './Jewelry'
import { HeaderShopMenuWatches } from './Watches'
import { HeaderShopMenuService } from './Service'

type HeaderPreOwnedMenuProps = {
  content: NavigationContent
  isVisible: boolean
}

export const HeaderPreOwnedMenu: FC<HeaderPreOwnedMenuProps> = ({ content, isVisible }) => {
  const { t } = useTranslation(['dropdown', 'navigation'])
  const [active, setActive] = useState<'watches' | 'jewels' | 'service'>('watches')

  return (
    <Container
      className={cn(
        'grid min-h-[45vh] grid-cols-[1fr_2fr] gap-x-2 pb-[96px] pt-10 xl:grid-cols-[1fr_3fr] xl:pt-[68px]',
        !isVisible && 'hidden',
      )}
      data-is-visible={isVisible}
    >
      <div>
        <MenuLabel>{t('shop.categories', { ns: 'dropdown' })}</MenuLabel>
        <MenuList space="large">
          <li>
            <MenuButton
              variant="large"
              onMouseEnter={() => setActive('watches')}
              title={t('preowned.watches', { ns: 'dropdown' })}
              isActive={active === 'watches'}
            >
              {t('preowned.watches', { ns: 'dropdown' })}
            </MenuButton>
          </li>
          <li>
            <MenuButton
              variant="large"
              onMouseEnter={() => setActive('jewels')}
              title={t('preowned.jewels', { ns: 'dropdown' })}
              isActive={active === 'jewels'}
            >
              {t('preowned.jewels', { ns: 'dropdown' })}
            </MenuButton>
          </li>
          <li>
            <MenuButton
              variant="large"
              onMouseEnter={() => setActive('service')}
              title={t('preowned.service', { ns: 'dropdown' })}
              isActive={active === 'service'}
            >
              {t('preowned.service', { ns: 'dropdown' })}
            </MenuButton>
          </li>
        </MenuList>
      </div>
      <div className="relative h-full w-full">
        <HideSubItemShop isVisible={active === 'watches'}>
          <HeaderShopMenuWatches {...content.preOwnedWatches} />
        </HideSubItemShop>
        <HideSubItemShop isVisible={active === 'jewels'}>
          <HeaderShopMenuJewelry {...content.preOwnedJewels} />
        </HideSubItemShop>
        <HideSubItemShop isVisible={active === 'service'}>
          <HeaderShopMenuService {...content.preOwnedJewelsService} />
        </HideSubItemShop>
      </div>
    </Container>
  )
}
